import axiosRequest from "@/api/axios-optimize"

// 判断字典项值是否存在
export function judgeDictValueExist(data = {}, config = {
  noShowLoading: true, // 不展示全局加载动画
  preventDuplicateRequestsType: "cancel"
}) {
  return axiosRequest.post(`/xiaobuAdmin/system/dictItem/judgeDictValueExist`, data, config)
}

// 判断字典项名称是否存在
export function judgeDictLabelExist(data = {}, config = {
  noShowLoading: true, // 不展示全局加载动画
  preventDuplicateRequestsType: "cancel"
}) {
  return axiosRequest.post(`/xiaobuAdmin/system/dictItem/judgeDictLabelExist`, data, config)
}

// 获取字典列表
export function getList(data = {}, config = {
  preventDuplicateRequestsType: "cancel",
  noShowLoading: true // 不展示全局加载动画
}) {
  return axiosRequest.get(`/xiaobuAdmin/system/dictItem`, { params: data, ...config})
}

// 获取字典详情
export function getDetailById(data = {}, config = {
  preventDuplicateRequestsType: "prevent"
}) {
  return axiosRequest.get(`/xiaobuAdmin/system/dictItem/${data.id}`, { params: {}, ...config})
}

// 更新字典
export function updateItem(data = {}, config = {
  preventDuplicateRequestsType: "prevent"
}) {
  return axiosRequest.put(`/xiaobuAdmin/system/dictItem/${data.dictItemId}`, data, config)
}

// 新增字典
export function createItem(data = {}, config = {
  preventDuplicateRequestsType: "prevent"
}) {
  return axiosRequest.post(`/xiaobuAdmin/system/dictItem`, data, config)
}

// 删除字典
export function deleteItem(data = {}, config = {
  preventDuplicateRequestsType: "prevent"
}) {
  return axiosRequest.delete(`/xiaobuAdmin/system/dictItem/${data.id}`, { ...config}) // 省略data入参 或 params入参
}

// 批量删除字典
export function batchDeleteItems(data = {}, config = {
  preventDuplicateRequestsType: "prevent"
}) {
  return axiosRequest.delete(`/xiaobuAdmin/system/dictItem/batchDelete`, { data, ...config})
}

// 改变字典状态
export function changeStatus(data = {}, config = {
  preventDuplicateRequestsType: "cancel"
}) {
  return axiosRequest.post(`/xiaobuAdmin/system/dictItem/changeStatus`, data, config)
}

// 通过字典id获取所有字典值
export function getALlDictItemByDictId(data = {}, config = {
  preventDuplicateRequestsType: "prevent"
}) {
  return axiosRequest.get(`/xiaobuAdmin/system/dictItem/getALlDictItemByDictId`, { params: data, ...config})
}

// 字典管理相关接口 结束